<template>
    <div>
        <Dialog :show="show" :show-close-button="true" @close="$emit('close')" width="600px">
            <div class="container">
                <h4>Preset teilen</h4>
                <div class="content">
                    <AdaButton title="Nutzer hinzufügen" class="shareButton" :unicon="true" icon="plus"
                               @click="openUserDialog" :loading="user_loading"></AdaButton>
                    <AdaTableClient :columns="columns" :rows="rows" :transformers="transformers"
                                    sortKey="user_name" @rowClicked="rowClicked"></AdaTableClient>
                    <LoaderDialog :show="deleteLoader">Bitte warten. Das Preset wird nicht mehr mit <br><b>{{loader_user}}</b><br>
                        geteilt ...
                    </LoaderDialog>
                </div>
            </div>
        </Dialog>
        <Dialog :show="showUserDialog" :show-close-button="true" @close="showUserDialog = false" :has-backdrop="false">
            <div class="userDialog container">
                <h4>Mit wem soll dieses Preset geteilt werden?</h4>
                <AdaTableClient :columns="user_columns" :rows="users" sortKey="last_name"
                                @rowClicked="rowClicked" :transformers="transformers"></AdaTableClient>
                <LoaderDialog :show="copyLoader">Bitte warten. Das Preset wird mit <br><b>{{loader_user}}</b><br>
                    geteilt ...
                </LoaderDialog>
            </div>
        </Dialog>
    </div>
</template>

<script>
    import Dialog from "../../components/dialogs/Dialog";
    import AdaTableClient from "../../components/dataTable/AdaTableClient";
    import moment from 'moment';
    import AdaButton from "../../components/buttons/AdaButton";
    import LoaderDialog from "../../components/dialogs/LoaderDialog";

    export default {
        name: "SharedPresetsDialog",
        components: {LoaderDialog, AdaButton, AdaTableClient, Dialog},
        props: ['show'],
        data() {
            return {
                selectedPreset: null,
                showUserDialog: false,
                user_loading: false,
                loader_user: 'Tony Stark',
                columns: [
                    {label: 'Name', name: 'user_name',},
                    {label: 'Geteilt seit', name: 'created_at', width: "130px"},
                    {label: 'Aktion', name: 'action', width: '90px'}
                ],
                user_columns: [
                    {label: 'Vorname', name: 'first_name', width: '130px'},
                    {label: 'Nachname', name: 'last_name', width: '130px'},
                    {label: 'Email', name: 'email', width: '220px'},
                    {label: 'Aktion', name: 'action', width: '90px'}
                ],
                transformers: [
                    {
                        propName: 'action',
                        transform: function (value) {
                            let res = '';
                            if (typeof value !== "undefined") {
                                value.forEach(action => {
                                    switch (action) {
                                        case 'delete':
                                            res += '<span style="cursor: pointer" data-type="delete" class="icon icon-delete"></span>';
                                            break;
                                        case 'share':
                                            res += '<button class="user_share_button" data-type="share"><span data-type="share" class="icon icon-share"></span>Teilen</button>';
                                            break;
                                    }
                                });
                            }
                            return res;
                        }
                    },
                    {
                        propName: 'created_at',
                        transform: function (value) {
                            let res = '';
                            if (typeof value !== "undefined") {
                                res = moment(value, moment.ISO_8601).format('DD.MM.YYYY');
                            }
                            return res;
                        }
                    },
                ],
            }
        },
        computed: {
            vuexState() {
                return this.$store.state.users;
            },
            presetsVuexState() {
                return this.$store.state.presets;
            },
            presets() {
                return this.$store.getters['presets/presetsTableData'];
            },
            copyLoader() {
                return this.presetsVuexState.presetsTableData.showCopyLoader;
            },
            deleteLoader() {
                return this.presetsVuexState.presetsTableData.showDeleteLoader;
            },
            rows() {
                if (this.presetsVuexState.presetsTableData.selectedPreset !== null) {
                    let ret = this.presets.filter(x => x.parent_id === this.presetsVuexState.presetsTableData.selectedPreset.id);
                    ret.forEach((row) => {
                        row.user_name = row.user.first_name + ' ' + row.user.last_name;
                    });
                    return ret;
                } else {
                    return [];
                }
            },
            users() {
                let users = JSON.parse(JSON.stringify(this.vuexState.users));
                let shared_users = JSON.parse(JSON.stringify(this.rows));
                if(shared_users.length !== 0) shared_users.push(shared_users[0]); // +1 to remove the author
                if (users.length !== 0) {
                    for (let i = 0; i < shared_users.length; i++) {
                        let id = i === 0 ? 'author_id' : 'user_id';
                        let index = users.findIndex(x => x.sso_id === shared_users[i][id]);
                        if (index !== -1) {
                            users.splice(index, 1);
                        }
                    }
                }
                users.forEach((row) => {
                    row.action = ['share'];
                });
                return users;
            }
        },
        methods: {
            rowClicked(data) {
                let preset_id = this.presetsVuexState.presetsTableData.selectedPreset.id;
                if (data.event.target.getAttribute('data-type') === "delete") {
                    this.loader_user = data.row.user_name;
                    this.deletePreset(data.row.id);
                }
                if (data.event.target.getAttribute('data-type') === "share") {
                    this.loader_user = data.row.first_name + ' ' + data.row.last_name;
                    this.copyPreset(preset_id, data.row.sso_id);
                }
            },
            async copyPreset(id, userId) {
                await this.$store.dispatch('presets/copyPreset', {id: id, userId: userId});
            },
            async deletePreset(id) {
                await this.$store.dispatch('presets/deletePreset', {id: id, type: 'share'});
            },
            async openUserDialog() {
                if (this.vuexState.users.length === 0) {
                    this.user_loading = true;
                    await this.$store.dispatch('users/fetch');
                    this.user_loading = false;
                }
                this.showUserDialog = true;
            }
        },
    }
</script>

<style lang="scss" scoped>

    .container {
        display: flex;
        flex-flow: column;
        width: 100%;
        transition: all .3s ease-in-out;
    }

    .content {
        position: relative;
    }

    .shareButton {
        position: absolute;
        right: 0;
        top: 3px;
    }

    :deep(.userDialog table tbody tr td.action){
        padding: 5px 10px;
    }

    :deep( td.action) {
        padding: 5px;
    }

    :deep( .user_share_button) {
        font-size: 14px;
        padding: 5px 12px;
        cursor: pointer;
        display: flex;
        align-items: center;
        height: 100%;
        position: relative;
        transition: width, margin 0.3s ease-in-out;
        border-radius: 4px;
        background-color: #00b6ed;
        color: white;
        border: none;
        justify-content: center;
        width: 120px;

        .icon {
            padding-right: 10px;
            padding-top: 3px;
            font-size: 15px !important;
        }
    }
</style>